import React from 'react';

import { CorporateSubscriberCirclePartner } from '../../utils/backend-api/partners';
import CorporateSubscriberCircleCard from './CorporateSubscriberCircleCard';
import styles from './styles.module.scss';

const CorporateSubscriberCircleContainer = ({
  cscPartners,
}: {
  cscPartners: CorporateSubscriberCirclePartner[];
}) => {
  return (
    <>
      <div className={styles.partnersTitle}>
        <h3 className={styles.title}>Corporate Subscriber Circle</h3>
        <div className={styles.titleDesign}></div>
      </div>
      <div className={styles.cscContainer}>
        {cscPartners.map((partner) => (
          <CorporateSubscriberCircleCard key={`csc-card-${partner.id}`} partner={partner} />
        ))}
        <a className={styles.learnMore} href="/partners#partnerships">
          Learn More
        </a>
      </div>
    </>
  );
};

export default CorporateSubscriberCircleContainer;
